export const sysVersion = "1.1.12";
export let apiUrl = "";
export const imageUrl = "https://mybee-api-server.onrender.com";

if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
  apiUrl = "http://localhost:3000";
  // dev code
} else {
  apiUrl = "https://mybee-api-server.onrender.com";

  // production code
}
